import styled from 'styled-components'
import { animated } from 'react-spring/web.cjs'

import CheckCircle from '../Icons/CheckCircle'
import { Colors } from 'styles'

const AnimatedDialogContent = animated.div

export const Content = styled(AnimatedDialogContent)`
  z-index: 9999;
  display: flex;
  align-items: center;
  position: fixed;
  width: 26.25rem;
  max-width: 90vw;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.875rem 0.625rem;
  overflow: hidden;
  background-color: ${Colors.white};
  border-radius: 6px;
  box-shadow: 0px 27px 80px rgba(0, 0, 0, 0.06),
    0px 11.28px 33.4221px rgba(0, 0, 0, 0.0431313),
    0px 6.0308px 17.869px rgba(0, 0, 0, 0.0357664),
    0px 3.38082px 10.0172px rgba(0, 0, 0, 0.03),
    0px 1.79553px 5.32008px rgba(0, 0, 0, 0.0242336),
    0px 0.747159px 2.21381px rgba(0, 0, 0, 0.0168687);

  &:before {
    content: '';
    width: 0.375rem;
    height: 100%;
    background-color: ${Colors.success};
    position: absolute;
    left: 0;
    top: 0;

    [dir='rtl'] & {
      left: unset;
      right: 0;
    }
  }
`

export const StyledCheckCircle = styled(CheckCircle)`
  width: 1.5rem;
  height: 1.5rem;
  margin-inline-end: 1.25rem;
  margin-inline-start: 0.5rem;
`
